import { Link } from "react-router-dom";

export const EngineeringPage: React.FC = () => {
  return (
    <div id="div-application-engineering" className="div application-engineering">
      <section className="block block-tight">
        <div className="wrap">
          <div className="detail-hero">
            <div className="icon-lg mono-mark">SE</div>
            <div>
              <div className="eyebrow">Enterprise &amp; web tooling</div>
              <h3 className="section-head" style={{ marginBottom: "6px" }}>
                SML Engineering
              </h3>
              <p className="lede" style={{ margin: 0 }}>
                Our engineering division. We build the web tooling that
                engineering teams run on — structured catalogs, specifications,
                and reporting, in place of spreadsheets that drift.
              </p>
              <div className="badge-row">
                <a
                  className="store-badge ready"
                  href="https://engineering.steamtownmedia.com"
                  target="_blank"
                  rel="noreferrer"
                >
                  <span className="dot"></span>
                  Open the web application
                </a>
              </div>
            </div>
          </div>

          <div className="feature-list">
            <div className="feature-item">
              <div className="f-title">Catalog and parts management</div>
              <p>
                Kits, part types, units, and statuses kept in one structured
                system rather than scattered across files.
              </p>
            </div>
            <div className="feature-item">
              <div className="f-title">Specifications and fitments</div>
              <p>
                Track specifications and the relationships between them, so the
                right part is matched to the right assembly every time.
              </p>
            </div>
            <div className="feature-item">
              <div className="f-title">Exportable reports</div>
              <p>
                Generate clean, shareable catalog documentation straight out of
                the data, ready to hand to a customer or a supplier.
              </p>
            </div>
            <div className="feature-item">
              <div className="f-title">Modern, maintained stack</div>
              <p>
                A React and TypeScript front end over a .NET API, hosted on
                Azure — built to be handed over, extended, and supported.
              </p>
            </div>
          </div>

          <div className="privacy-note">
            <span className="mono">CUSTOM WORK</span>
            <span>
              Need engineering tooling built for your own team? We take on a
              small number of projects at a time.
            </span>
            <Link to="/contact">Get in touch &rarr;</Link>
          </div>
        </div>
      </section>
    </div>
  );
};
